export default "/static/3978e78c4f438334.png"